import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQVersicherungSection = () => <FAQSectionI18n translationPrefix="industryVersicherung" bgClass="bg-secondary/30" />;
export default FAQVersicherungSection;
